import Vue from 'vue';
import unitTypes from './unitTypes';

Vue.prototype.$unitTypes = unitTypes;



// WEBPACK FOOTER //
// ./src/variables/index.js